import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/index.vue'

const routes = [
  {
    path: '/',
    name: 'home',

    component: HomeView,
    redirect: '/',
    children: [
      {
        path: '/',
        component: () => import('../views/consultationGuidance.vue'),
        meta: { title: '首页' },
      },
      {
        path: '/chat',
        component: () => import('../views/chat.vue'),
        meta: { title: '聊天页面' },
      },
      {
        path: '/textContent',
        component: () => import('../views/textContent.vue'),
        meta: { title: '文本内容' },
      },
      {
        path: '/writeLetters',
        component: () => import('../views/writeLetters.vue'),
        meta: { title: '智能写信助手' },
      },
      {
        path: '/letterInspection',
        component: () => import('../views/letterInspection.vue'),
        meta: { title: '智能信件检查' },
      },
      {
        path: '/consultationGuidance',
        component: () => import('../views/consultationGuidance.vue'),
        meta: { title: '咨询引导' },
      },
      {
        path: '/responseCaliber',
        component: () => import('../views/responseCaliber.vue'),
        meta: { title: '答复口径推荐' },
      },
      {
        path: '/legalBasis',
        component: () => import('../views/legalBasis.vue'),
        meta: { title: '法律依据推荐' },
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
